var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"unscored-char-icon"},[_c('font-awesome-icon',{attrs:{"icon":[ 'fas', 'highlighter' ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }